module.exports = __webpack_public_path__ + "img/2019qinglongxia-3.65217381.jpg";